import * as Yup from "yup";
import { validateTelephone } from "../common";

export const settingSMSSchema = Yup.object().shape({
  phoneNumber: validateTelephone,
});
